import React from 'react'
import './Question.css';

const Question = (props) => {
    return (
        <div>

        <div id="question">
            <h1>{props.question}</h1>
        </div>


    
        </div>
    )
}

export default Question
